/*
 * Jira Ticket:
 * Created Date: Fri, 17th Jan 2020, 16:14:54 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import * as Query from './queries';

export default ({ type, resource, params }) => {
  // override ra-data-graphql-simple predicted queries here e.g.
  if (resource === 'Organisation' && type === 'GET_ONE') {
    return Query.getOneOrganisationQuery;
  }
  if (resource === 'Organisation' && type === 'GET_MANY') {
    return Query.getListOrganisationQuery;
  }
  if (
    resource === 'Site' &&
    (type === 'GET_LIST' || type === 'GET_MANY_REFERENCE')
  ) {
    return Query.getListSiteQuery;
  }
  if (resource === 'Site' && type === 'GET_ONE') {
    return Query.getOneSiteQuery;
  }
  if (resource === 'Site' && type === 'UPDATE') {
    return Query.updateSiteMutation;
  }
  if (resource === 'Site' && type === 'CREATE') {
    return Query.createSiteMutation;
  }
  if (resource === 'Tower' && type === 'GET_ONE') {
    return Query.getOneTowerQuery;
  }
  if (resource === 'Project' && type === 'GET_MANY') {
    return Query.getManyProjectQuery;
  }
  if (resource === 'TowerType' && type === 'GET_MANY') {
    return Query.getManyTowerTypeQuery;
  }
  if (resource === 'Subcontract' && type === 'CREATE') {
    return Query.createSubcontractMutation;
  }
  if (resource === 'User' && type === 'GET_ONE') {
    return Query.getOneUserQuery;
  }
  if (resource === 'TowerInspection' && type === 'GET_LIST') {
    return Query.getListTowerInspectionQuery;
  }
  if (resource === 'TowerInspection' && type === 'GET_ONE') {
    return Query.getOneTowerInspectionQuery;
  }
  if (resource === 'Employment' && type === 'GET_ONE') {
    return Query.getOneEmploymentQuery;
  }
  if (resource === 'Region' && type === 'CREATE') {
    return Query.createRegionMutation;
  }
  if (resource === 'SubscriptionTier' && type === 'GET_LIST') {
    return Query.getListSubscriptionTierQuery;
  }
  if (resource === 'SubscriptionTier' && type === 'GET_ONE') {
    return Query.getOneSubscriptionTierQuery;
  }
  if (resource === 'Template' && type === 'GET_ONE') {
    return Query.getOneTemplateQuery;
  }
  if (resource === 'Template' && type === 'GET_LIST') {
    return Query.getListTemplateQuery;
  }
};
